<template>
    <div class="product-wishlist d-flex"
         :class="{'product-wishlist--active': isVariationInWishList}"
         @click="switchState()">
        <svg class="bi" width="18" height="17" fill="currentColor">
            <use xlink:href="#svg-wishlist"/>
        </svg>
    </div>
</template>

<script>
import {mapState} from "vuex";

const NotificationService = require("ceres/app/services/NotificationService");

export default {
    props: {
        itemId: Number
    },
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        isVariationInWishList() {
            return this.wishListIds.includes(this.itemId);
        },
        ...mapState({
            wishListIds: state => state.wishList.wishListIds
        })
    },
    methods: {
        switchState() {
            if (this.isVariationInWishList) {
                this.removeFromWishList();
            } else {
                this.addToWishList();
            }
        },
        addToWishList() {
            if (!this.isLoading) {
                this.isLoading = true;
                this.$store.dispatch("addToWishList", this.itemId).then(
                    response => {
                        this.isLoading = false;

                        NotificationService.success(
                            this.$translate("Ceres::Template.singleItemWishListAdded")
                        ).closeAfter(3000);
                    },
                    error => {
                        this.isLoading = false;
                    });
            }
        },
        removeFromWishList() {
            if (!this.isLoading) {
                this.isLoading = true;
                this.$store.dispatch("removeWishListItem", {id: this.itemId}).then(response => {
                        this.isLoading = false;

                        NotificationService.success(
                            this.$translate("Ceres::Template.singleItemWishListRemoved")
                        ).closeAfter(3000);
                    },
                    error => {
                        this.isLoading = false;
                    });
            }
        }
    }
}

</script>
